import React from 'react'
import './articles.css'
const Hiring = () => {
  return (
    <div class="articlecontainer">
        <h1>Registering Employees with the Social Security and Health Insurance Institute (ISSH) in Albania</h1>
        <p>When starting a business in Albania and hiring employees, one of the key steps is to ensure compliance with the country’s Social and Health Insurance regulations. All employers are required to register their employees with the Social and Health Insurance Institute (ISSH) and to file monthly payroll tax reports. Here’s a step-by-step guide to help you navigate the process.</p>
        
        <h2>Step-by-Step Guide to Registering Employees with the ISSH</h2>
        <h3>Before Registering Employees, Ensure You Have the Following Documents:</h3>
        <ul>
            <li>Company Registration Certificate (NIPT) – Issued by the National Registration Center (QKB).</li>
            <li>Employment Contracts – Signed agreements with each employee outlining terms of employment.</li>
            <li>Employee Identification Document – A national ID card or passport to verify identity.</li>
            <li>Work Permit – Required for foreign employees from the Ministry of Finance and Economy.</li>
        </ul>
        
        <h3>Step 1: Register Employees Through the E-Tax Portal</h3>
        <p>The employee registration process is done through the E-Tax Portal, which is the government’s online tax system.</p>
        <ul>
            <li>Log in to the E-Tax Portal.</li>
            <li>Navigate to the "Employee Declaration" section.</li>
            <li>Submit required employee details, salary, and contract information.</li>
        </ul>
        <p class="important">Important: Registration must be completed at least 24 hours before the employee starts working.</p>
        
        <h3>Step 2: Declare Employee to ISSH</h3>
        <ul>
            <li>Go to the "Employee Declaration Form" section in the E-Tax portal.</li>
            <li>Enter employee details, including social security number, salary, and employment status.</li>
            <li>Submit the form within 48 hours of employment.</li>
        </ul>
        
        <h3>Step 3: Deduct and Pay Social Security and Health Insurance Contributions</h3>
        <p>Employers must deduct and pay contributions for social security and health insurance:</p>
        <ul>
            <li>Social Security: Employer (15%), Employee (11.2%) – Total: 26.2%.</li>
            <li>Health Insurance: Employer (1.7%), Employee (1.7%) – Total: 3.4%.</li>
            <li><strong>Total Payroll Tax:</strong> Employer (16.7%), Employee (12.9%) – Grand Total: 29.6%.</li>
        </ul>
        
        <h3>Step 4: Submit Monthly Payroll Tax Reports</h3>
        <p>Employers must file monthly payroll tax reports via the E-Tax Portal:</p>
        <ul>
            <li>Taxes must be paid by the 20th of the following month.</li>
            <li>Reports must be submitted on time to avoid penalties.</li>
        </ul>
        
        <h3>What If You’re the Only Person in the Company?</h3>
        <p>If you are self-employed, you must still register yourself as both the owner and employee and pay both employer and employee contributions.</p>
        
        <h3>Penalties for Non-Compliance</h3>
        <ul>
            <li>Fines for late registration or incorrect declarations.</li>
            <li>Late payments may result in penalties.</li>
            <li>Non-payment or incorrect payments can lead to fines up to 500,000 ALL (~€5,000).</li>
        </ul>
        
        <h2>Final Thoughts</h2>
        <ul>
            <li>Social security and health insurance registration is mandatory for businesses hiring employees.</li>
            <li>Self-employed individuals must follow the same registration process.</li>
            <li>Stay compliant to avoid penalties and legal issues.</li>
        </ul>
    </div>
  )
}

export default Hiring